// translation.guard.ts
import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TranslationService } from '../i18n/translation.service';
import { CommonService } from '../shared/commonService';

@Injectable({
  providedIn: 'root'
})
export class TranslationGuard implements CanActivate {

  constructor(
    private translationService: TranslationService,
    private commonService: CommonService,
    private router: Router
  ) {}

  async canActivate(): Promise<boolean> {
    const language = this.commonService.getLanguage();
    this.translationService.setLanguage(language);

    try {
      await this.translationService.translateKeyLang('HOME.META_DESCRIPTION', language);
      return true;
    } catch (error) {
      console.error('Error loading translations:', error);
      return false;
    }
  }
}
